<template>
  <div class="panel font-style">
    <span>© Copyright 2018 The Tigo Author <el-button type="text" @click="contactInfo" class="font-style">Karl Lee</el-button></span>
  </div>
</template>

<script>
  export default {
    name: "DocumentationFooter",
    methods: {
      contactInfo() {
        this.$alert('Contact Author: karlvorndoenitz@gmail.com', 'Email', {
          confirmButtonText: 'OK',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${ action }`
            });
          }
        });
      }
    }
  }
</script>

<style scoped>
  .font-style {
    font-size: 20px;
  }
  .panel {
    height: 60px;
    background-color: #2f343f;
    text-align: center;
    color: #ffffff;
    font-family: "Avenir", serif;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/en/DocumentationFooter.vue